<template>
  <MultiDocsBlock20321
    v-if="saveForLater20321Variant() === 'B'"
    v-on-visible.once="trackImpression"
    :view="view"
    showFreeBooks
    :docViewEventProperties="docViewEventProperties"
  />
  <BooksBlock
    v-else
    v-on-visible.once="trackImpression"
    :view="view"
    :docViewEventProperties="docViewEventProperties"
  />
</template>

<script setup lang="ts">
import { Mixpanel } from '@/analytics/mixpanel'
import BooksBlock from '@/app/components/listing/BooksBlock.vue'
import MultiDocsBlock20321 from '@/app/components/listing/MultiDocsBlock20321.vue'
import { vOnVisible } from '@/helpers/directives'
import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'
import { saveForLater20321Variant } from '@/services/ab/experiments'

const props = defineProps<{
  view: ListView
}>()

/** Track the block impression using the full list size. */
function trackImpression(): void {
  Mixpanel.trackWantToReadBlockImpression(props.view.dataLength)
}

/** Return the Want to Read details added to this book's Doc View event. */
function docViewEventProperties(doc: ListItem): Record<string, unknown> {
  return {
    'Want to Read List Size': props.view.dataLength,
    'Want to Read Is Onboarding Seeded':
      props.view.customList?.onboarding_doc_ids?.includes(doc.id) ?? false,
  }
}
</script>
